import React, { PropsWithChildren } from "react"

import { styled, useMediaQuery } from "@mui/material"

export const MainLayout = ({ children }: PropsWithChildren) => {
  const matches = useMediaQuery("(min-width:600px)")

  return (<>
    <Container className="sfl-wrapper" sx={{ paddingTop: matches ? "80px" : "30px" }}>
      {children}
    </Container>
    <div id="sfl-footer"/>
  </>)
}

const Container = styled("main")({
  minHeight: "100vh",
  width: "100%",
})
